export default "__VITE_ASSET__BJNiHS5V__"